export default __webpack_public_path__ + "static/media/G0860.Breech_allfours_delay2.1692880560000.2526bc13.jpg";